import React, { useCallback, useEffect, useState } from 'react'
import {
  Box,
  Container,
  Text,
  Select,
  Input,
  Switch,
  Button,
  Center,
  Flex,
  CircularProgress,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  ModalHeader,
  UnorderedList,
  ListItem,
  Image,
  SimpleGrid,
  Divider,
} from '@chakra-ui/react'
import DocumentUploadHeader from 'Components/Headers/DocumentUploadHeader'
import Layout from 'Components/Layout'
import FileUpload from 'Components/FileUpload'
import { useDropzone } from 'react-dropzone'
import { PospImages } from 'Assets/Posp'
import {
  useFileUploadMutation,
  useGetUploadedDocumentsQuery,
  useLogoutUserMutation,
  useReuploadDocumentsMutation,
} from 'Services/API/posp.api'
import Compressor from 'compressorjs'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { retry } from '@reduxjs/toolkit/dist/query'
import { ToastService } from 'Services/toast.service'
import { USER_REGISTRATION_TYPE, maxFileSize, gstRegex } from 'Constants'
import { useDeviceType } from 'app/hooks'
import { resetUser, updateUserState } from 'features/Authentication'
import { useIdleTimer } from 'react-idle-timer'

const EducationOptions = [
  {
    label: '10th Marksheet',
    value: '10th_MARKSHEET',
  },
  {
    label: '12th Marksheet',
    value: '12th_MARKSHEET',
  },
  {
    label: 'Graduation',
    value: 'GRADUATION',
  },
  {
    label: 'Post Graduation',
    value: 'POST_GRADUATION',
  },
]

const BankOptions = [
  {
    label: 'Cancelled Cheque',
    value: 'CANCELLED_CHECK',
  },
  {
    label: 'Bank Passbook',
    value: 'BANK_PASSBOOK',
  },
  {
    label: 'Bank Statement',
    value: 'BANK_STATEMENT',
  },
]

const strictGstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/

const DocumentUpload = () => {
  const store = useSelector((store: any) => store.user)
  const { pan_number } = store.authenticatedUser
  const { userState, isRegistered } = store
  const { message: remarks, status: docUploadStatus } = userState.doc_upload
  const { isMobile } = useDeviceType()
  const [panFront, setPanFront] = useState<any>(null)
  const [panFrontPreview, setPanFrontPreview] = useState<any>(null)
  const [addressProofFront, setAddressProofFront] = useState<any>(null)
  const [addressProofFrontPreview, setAddressProofFrontPreview] = useState<any>(null)
  const [addressProofBack, setAddressProofBack] = useState<any>(null)
  const [addressProofBackPreview, setAddressProofBackPreview] = useState<any>(null)
  const [education, setEducation] = useState<any>(null)
  const [educationPreview, setEducationPreview] = useState<any>(null)
  const [passport, setPassport] = useState<any>(null)
  const [passportPreview, setPassportPreview] = useState<any>(null)
  const [cheque, setCheque] = useState<any>(null)
  const [chequePreview, setChequePreview] = useState<any>(null)
  const [noc, setNoc] = useState<any>(null)
  const [nocPreview, setNocPreview] = useState<any>(null)
  const [gstDoc, setGstDoc] = useState<any>(null)
  const [gstDocPreview, setGstDocPreview] = useState<any>(null)
  const [hasGst, setHasGst] = useState<boolean>(false)
  const [gstNumber, setGstNumber] = useState<string>('')

  const [educationChoice, setEducationChoice] = useState('')
  const [bankChoice, setBankChoice] = useState('')
  const [apiErrors, setApiErrors] = useState<any>({})
  const [modalRemarks, setModalRemarks] = useState<any>(null)
  const [reuploadValues, setReuploadValues] = useState<number[]>([])

  console.log('reupload', reuploadValues)
  const [isOpen, setIsOpen] = useState(false)

  const { isLoggedIn, authenticatedUser } = useSelector((state: any) => state.user)
  const dispatch = useDispatch()
  const location = useLocation()
  // LOGOUT FUNCTIONALITIES

  // const [logoutUser] = useLogoutUserMutation({})

  // const handleLogout = async () => {
  //   try {
  //     const logoutUserResp = await logoutUser({
  //       idle: true,
  //     })
  //     // console.log(logoutUserResp)
  //     if (logoutUserResp?.data?.status && isLoggedIn) {
  //       ToastService.showInfoToast({
  //         title: 'Session Timeout',
  //         message: 'You have been auto logout due to inactivity',
  //       })
  //       navigate('/')
  //       localStorage.clear()
  //       sessionStorage.clear()
  //       dispatch(resetUser())
  //       dispatch(updateUserState(userState))
  //     }
  //   } catch (e) {
  //     console.log(e)
  //   }
  // }
  // IDLE TIMER FOR AUTO LOGOUT
  // const [state, setState] = useState<string>('Active')
  // const [count, setCount] = useState<number>(0)
  // const [remaining, setRemaining] = useState<number>(0)

  // const onIdle = () => {
  //   // setState('Idle')
  //   handleLogout()
  // }

  // const onActive = () => {
  //   setState('Active')
  // }

  // const onAction = () => {
  //   setCount(count + 1)
  // }

  // const { getRemainingTime } = useIdleTimer({
  //   onIdle,
  //   onActive,
  //   onAction,
  //   timeout: 10_000 * 6 * 5,
  //   throttle: 500,
  // })

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setRemaining(Math.ceil(getRemainingTime() / 1000))
  //   }, 500)

  //   return () => {
  //     clearInterval(interval)
  //   }
  // })

  const [haveRemarks, setHaveRemarks] = useState<any>({
    pan: false,
    addressFront: false,
    addressBack: false,
    education: false,
    passport: false,
    bankDetails: false,
    noc: false,
    gst: false,
  })

  // const [fileTypes, setFileTypes] = useState({
  //   aadhar_back_file: '',
  //   aadhar_front_file: '',
  //   bank_details_doc_file: '',
  //   education_doc_file: '',
  //   pan_file: '',
  //   photo_file: '',
  // });

  const openRemarkModal = (type: string) => {
    //

    if (remarks[type]) {
      const remarkList: any[] = []
      remarks[type].forEach((val: any) => {
        remarkList.push(val)
      })

      setModalRemarks(remarkList)
    }
    setIsOpen(true)
  }

  const filePreviewMap: any = {
    pan_file: {
      method: setPanFront,
      previewMethod: setPanFrontPreview,
    },
    aadhar_front_file: {
      method: setAddressProofFront,
      previewMethod: setAddressProofFrontPreview,
    },
    aadhar_back_file: {
      method: setAddressProofBack,
      previewMethod: setAddressProofBackPreview,
    },
    photo_file: {
      method: setPassport,
      previewMethod: setPassportPreview,
    },
    education_doc_file: {
      method: setEducation,
      previewMethod: setEducationPreview,
    },
    bank_details_doc_file: {
      method: setCheque,
      previewMethod: setChequePreview,
    },
    noc_doc_file: {
      method: setNoc,
      previewMethod: setNocPreview,
    },
    gst_doc_file: {
      method: setGstDoc,
      previewMethod: setGstDocPreview,
    },
  }

  // console.log('fileTypes', fileTypes);

  const navigate = useNavigate()

  const { data: uploadedDocuments, isLoading: getUploadedDocLoading } =
    useGetUploadedDocumentsQuery(
      {},
      {
        refetchOnMountOrArgChange: true,
      },
    )

  useEffect(() => {
    const fileType: any = {}
    if (uploadedDocuments?.data) {
      if (uploadedDocuments.data.gst_number) {
        setGstNumber(uploadedDocuments.data.gst_number)
        setHasGst(true)
      } else if (uploadedDocuments.data.gst_doc_file) {
        setHasGst(false)
      }

      Object.keys(uploadedDocuments?.data)?.forEach((key) => {
        if (key === 'bank_details_doc_type') {
          setBankChoice(uploadedDocuments.data[key])
        }

        if (key === 'education_doc_type') {
          setEducationChoice(uploadedDocuments.data[key])
        }
        const url = uploadedDocuments?.data[key]
        if (url && typeof url === 'string') {
          const fileWithType = url.split('.')
          const type = fileWithType.splice(-1)[0] === 'pdf' ? 'application/pdf' : 'jpeg'
          const file = fileWithType.join('.')
          filePreviewMap[key]?.method({
            type,
          })
          filePreviewMap[key]?.previewMethod(file)
        }
      })
    }
  }, [getUploadedDocLoading, uploadedDocuments])

  const [documentUpload, { isLoading: fileUploadLoading }] = useFileUploadMutation()

  const [documentReupload, { isLoading: documentReuploadLoading }] = useReuploadDocumentsMutation()

  const handleFileCancel = (key: string) => {
    switch (key) {
      case 'panFront': {
        setPanFront(null)
        setPanFrontPreview('')
        break
      }
      case 'addressProofFront': {
        setAddressProofFront(null)
        setAddressProofFrontPreview('')
        break
      }
      case 'addressProofBack': {
        setAddressProofBack(null)
        setAddressProofBackPreview('')
        break
      }
      case 'education': {
        setEducation(null)
        setEducationPreview('')
        break
      }
      case 'passport': {
        setPassport(null)
        setPassportPreview('')
        break
      }
      case 'cheque': {
        setCheque(null)
        setChequePreview('')
        break
      }

      case 'noc': {
        setNoc(null)
        setNocPreview('')
        break
      }
      case 'gstDoc': {
        setGstDoc(null)
        setGstDocPreview('')
        break
      }
    }
  }

  // Pan Front Upload

  const blobToFile = (theBlob: any, fileName: string) => {
    const myFile = new File([theBlob], fileName, {
      type: theBlob.type,
    })
    return myFile
  }

  const formatFile = (file: File, method: any, previewMethod: any) => {
    const fileType = file.type
    if (fileType === 'image/png' || fileType === 'image/jpg' || fileType === 'image/jpeg') {
      const compressor: any = new Compressor(file, {
        quality: 0.2,
        async success(result) {
          const file = blobToFile(result, 'pancard.jpg')
          method(file)
          previewMethod(URL.createObjectURL(file))
        },
      })
      return compressor
    } else {
      method(file)
      previewMethod(URL.createObjectURL(file))
    }
  }

  // Pan Front End
  const onPanFrontDrop = useCallback((acceptedFiles: File[]) => {
    formatFile(acceptedFiles[0], setPanFront, setPanFrontPreview)
    setHaveRemarks((prev: any) => ({ ...prev, pan: false }))

    // setHaveRemarks({ ...haveRemarks, pan: false })
    setReuploadValues((prev) => prev.filter((val) => val !== 2))
  }, [])

  const PanFrontUpload = useDropzone({
    onError: () => {
      ToastService.showErrorToast({ title: 'Error', message: 'Invalid file' })
    },
    onDrop: onPanFrontDrop,
    multiple: false,
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png'],
      'application/pdf': ['.pdf'],
    },
  })

  // Address Proof front
  const onAddressProofFrontDrop = useCallback((acceptedFiles: File[]) => {
    formatFile(acceptedFiles[0], setAddressProofFront, setAddressProofFrontPreview)
    setHaveRemarks((prev: any) => ({ ...prev, addressFront: false }))
    setReuploadValues((prev) => prev.filter((val) => val !== 4))
  }, [])

  const addressProofFrontUpload = useDropzone({
    onError: () => {
      ToastService.showErrorToast({ title: 'Error', message: 'Invalid file' })
    },
    onDrop: onAddressProofFrontDrop,
    multiple: false,
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png'],
      'application/pdf': ['.pdf'],
    },
  })

  // Address Proof Back
  const onAddressProofBackDrop = useCallback((acceptedFiles: File[]) => {
    formatFile(acceptedFiles[0], setAddressProofBack, setAddressProofBackPreview)
    // setHaveRemarks({ ...haveRemarks, addressBack: false })
    setHaveRemarks((prev: any) => ({ ...prev, addressBack: false }))

    setReuploadValues((prev) => prev.filter((val) => val !== 5))
  }, [])

  const addressProofBackUpload = useDropzone({
    onError: () => {
      ToastService.showErrorToast({ title: 'Error', message: 'Invalid file' })
    },
    onDrop: onAddressProofBackDrop,
    multiple: false,
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png'],
      'application/pdf': ['.pdf'],
    },
  })

  // Education
  const onEducationBackDrop = useCallback((acceptedFiles: File[]) => {
    formatFile(acceptedFiles[0], setEducation, setEducationPreview)
    // setHaveRemarks({ ...haveRemarks, education: false })
    setHaveRemarks((prev: any) => ({ ...prev, education: false }))

    setReuploadValues((prev) => prev.filter((val) => val !== 6))
  }, [])

  const educationUpload = useDropzone({
    onError: () => {
      ToastService.showErrorToast({ title: 'Error', message: 'Invalid file' })
    },
    onDrop: onEducationBackDrop,
    multiple: false,
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png'],
      'application/pdf': ['.pdf'],
    },
  })

  // Passport
  const onPassportDrop = useCallback((acceptedFiles: File[]) => {
    formatFile(acceptedFiles[0], setPassport, setPassportPreview)
    // setHaveRemarks({ ...haveRemarks, passport: false })
    setHaveRemarks((prev: any) => ({ ...prev, passport: false }))

    setReuploadValues((prev) => prev.filter((val) => val !== 7))
  }, [])

  const passportUpload = useDropzone({
    onError: () => {
      ToastService.showErrorToast({ title: 'Error', message: 'Invalid file' })
    },
    onDrop: onPassportDrop,
    multiple: false,
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png'],
    },
  })

  // cheque
  const onCheckDrop = useCallback((acceptedFiles: File[]) => {
    formatFile(acceptedFiles[0], setCheque, setChequePreview)
    // setHaveRemarks({ ...haveRemarks, bankDetails: false })
    setHaveRemarks((prev: any) => ({ ...prev, bankDetails: false }))

    setReuploadValues((prev) => prev.filter((val) => val !== 8))
  }, [])

  const checkUpload = useDropzone({
    onError: () => {
      ToastService.showErrorToast({ title: 'Error', message: 'Invalid file' })
    },
    onDrop: onCheckDrop,
    multiple: false,
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png'],
      'application/pdf': ['.pdf'],
    },
  })

  // noc

  const onNocDrop = useCallback((acceptedFiles: File[]) => {
    formatFile(acceptedFiles[0], setNoc, setNocPreview)
    // setHaveRemarks({ ...haveRemarks, bankDetails: false })
    setHaveRemarks((prev: any) => ({ ...prev, noc: false }))

    setReuploadValues((prev) => prev.filter((val) => val !== 1))
  }, [])

  const nocUpload = useDropzone({
    onError: () => {
      ToastService.showErrorToast({ title: 'Error', message: 'Invalid file' })
    },
    onDrop: onNocDrop,
    multiple: false,
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png'],
      'application/pdf': ['.pdf'],
    },
  })

  const onGstDocDrop = useCallback((acceptedFiles: File[]) => {
    formatFile(acceptedFiles[0], setGstDoc, setGstDocPreview)
    setHaveRemarks((prev: any) => ({ ...prev, gst: false }))
    setReuploadValues((prev) => prev.filter((val) => val !== 9))
  }, [])

  const gstDocUpload = useDropzone({
    onError: () => {
      ToastService.showErrorToast({ title: 'Error', message: 'Invalid file' })
    },
    onDrop: onGstDocDrop,
    multiple: false,
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png'],
      'application/pdf': ['.pdf'],
    },
  })

  const docKeyIdMap = (key: string) => {
    let id = 0
    switch (key) {
      case 'DOCUMENTS':
        id = 6
        break

      case 'PAN':
        id = 2
        break

      case 'AADHAR_FRONT':
        id = 4
        break

      case 'AADHAR_BACK':
        id = 5
        break

      case 'PHOTOGRAPH':
        id = 7
        break

      case 'BANK_DETAILS':
        id = 8
        break

      case 'NOC':
        id = 1
        break

      case 'GST':
        id = 9
        break
    }

    return id
  }

  const docRemarkKeyMap = (key: string): { docKey: string; docFile: any } => {
    let docKey = ''
    let docFile
    switch (key) {
      case 'DOCUMENTS':
        docKey = 'education_doc_file'
        docFile = education
        break

      case 'PAN':
        docKey = 'pan_file'
        docFile = panFront
        break

      case 'AADHAR_FRONT':
        docKey = 'aadhar_front_file'
        docFile = addressProofFront
        break

      case 'AADHAR_BACK':
        docKey = 'aadhar_back_file'
        docFile = addressProofBack
        break

      case 'PHOTOGRAPH':
        docKey = 'photo_file'
        docFile = passport
        break

      case 'BANK_DETAILS':
        docKey = 'bank_details_doc_file'
        docFile = cheque
        break

      case 'NOC':
        docKey = 'noc_doc_file'
        docFile = noc
        break

      case 'GST':
        docKey = 'gst_doc_file'
        docFile = gstDoc
        break
    }

    return { docKey, docFile }
  }

  const handleFileUpload = async () => {
    if (remarks && Object.keys(remarks)?.length) {
      try {
        const formData = new FormData()

        Object.keys(remarks).forEach((key) => {
          const getDocValues = docRemarkKeyMap(key)
          formData.append(getDocValues.docKey, getDocValues.docFile)
        })

        if (hasGst && gstNumber) {
          formData.append('gst_number', gstNumber)
        }

        const response = await documentReupload(formData).unwrap()
        if (response?.status === 200) {
          ToastService.showSuccessTaost({ title: 'success', message: 'Data saved successfully' })
          navigate('/registration-status')
        }
      } catch (err: any) {
        if (err.data.status === 400 && Object.keys(err.data.data)?.length) {
          const errors: any = {}
          Object.keys(err.data.data).forEach((key: string) => {
            errors[key] = err.data.data[key][0]
          })
          setApiErrors(errors)
        }
      }
    } else {
      try {
        const formData = new FormData()
        formData.append('pan_file', panFront)
        formData.append('aadhar_front_file', addressProofFront)
        formData.append('aadhar_back_file', addressProofBack)
        formData.append('education_doc_type', educationChoice)
        formData.append('education_doc_file', education)
        formData.append('photo_file', passport)
        formData.append('bank_details_doc_type', bankChoice)
        formData.append('bank_details_doc_file', cheque)
        if (hasGst) {
          formData.append('gst_number', gstNumber)
        }
        if (gstDoc) {
          formData.append('gst_doc_file', gstDoc)
        }

        const response = await documentUpload(formData).unwrap()
        if (response?.status === 200) {
          ToastService.showSuccessTaost({ title: 'success', message: 'Data saved successfully' })
          navigate('/registration-status')
        }
      } catch (err: any) {
        if (err.data.status === 400 && Object.keys(err.data.data)?.length) {
          const errors: any = {}
          Object.keys(err.data.data).forEach((key: string) => {
            errors[key] = err.data.data[key][0]
          })
          setApiErrors(errors)
        }
      }
    }
  }

  const checkRemarkResolved = () => (Object.values(haveRemarks).includes(true) ? false : true)

  const checkVerificationStatus = (key: string) => {
    let result = true

    if (
      docUploadStatus === 'INCOMPLETE' ||
      docUploadStatus === 'PENDING' ||
      key in (remarks || {})
    ) {
      result = false
    }

    return result
  }

  useEffect(() => {
    if (remarks) {
      const excludeVals: number[] = []

      Object.keys(remarks).forEach((key) => {
        excludeVals.push(docKeyIdMap(key))
      })

      setReuploadValues(excludeVals)
    }
  }, [])

  useEffect(() => {
    const newHaveRemarks = { ...haveRemarks }

    Object.keys(remarks || {})?.forEach((key) => {
      if (key === 'DOCUMENTS') {
        newHaveRemarks.education = true
      } else if (key === 'PAN') {
        newHaveRemarks.pan = true
      } else if (key === 'AADHAR_FRONT') {
        newHaveRemarks.addressFront = true
      } else if (key === 'AADHAR_BACK') {
        newHaveRemarks.addressBack = true
      } else if (key === 'PHOTOGRAPH') {
        newHaveRemarks.passport = true
      } else if (key === 'BANK_DETAILS') {
        newHaveRemarks.bankDetails = true
      } else if (key === 'NOC') {
        newHaveRemarks.noc = true
      } else if (key === 'GST') {
        newHaveRemarks.gst = true
      }
    })

    setHaveRemarks(newHaveRemarks)
  }, [remarks])

  return (
    <Layout HeaderComponent={<DocumentUploadHeader />}>
      <Modal
        isOpen={isOpen}
        size={isMobile ? 'xs' : 'md'}
        onClose={() => {
          setIsOpen(false)
        }}
      >
        <ModalOverlay />
        <ModalContent p={3}>
          <ModalCloseButton />
          <ModalHeader>Remarks</ModalHeader>
          <ModalBody>
            <UnorderedList>
              {modalRemarks &&
                modalRemarks.map((val: any, ind: any) => <ListItem key={ind}>{val}</ListItem>)}
            </UnorderedList>
          </ModalBody>
        </ModalContent>
      </Modal>
      <Container maxWidth='100%' position='relative'>
        {fileUploadLoading || documentReuploadLoading ? (
          <Box
            height='100%'
            width='100%'
            zIndex={10}
            position='absolute'
            left='0%'
            top='0%'
            background='rgba(128,128,128,0.3)'
          >
            <Flex width={'100%'} height='100%' justifyContent={'center'} alignItems='center'>
              <CircularProgress isIndeterminate color='green.300' />
            </Flex>
          </Box>
        ) : null}
        <Text pt='6' px={isMobile ? 2 : 6} color='#828282' fontStyle='italic' fontSize='xs'>
          Kindly only upload the original documents below 4 MB. Xerox of proofs will not be
          accepted.
        </Text>
        <Text mb={2} px={isMobile ? 2 : 6} color='#828282' fontStyle='italic' fontSize='xs'>
          (Only JPG/JPEG/PNG/PDF is accepted)
        </Text>
        <SimpleGrid columns={isMobile ? 1 : 3} spacing={8} overflowX='scroll'>
          {/* <Flex> */}

          <Box borderRight={isMobile ? 'none' : '1px solid #D8D8D8'}>
            <Center flexDirection={'column'}>
              <Box>
                <Flex alignItems={'center'} justifyContent={'space-between'} pb={2}>
                  <Text color='#2C2C2C' fontSize='md'>
                    01. PAN CARD: {pan_number?.replace(/[A-Z]/g, 'X')}
                  </Text>
                  {checkVerificationStatus('PAN') && (
                    <Image ml={2} height={'15px'} src={PospImages.CheckmarkDarkIcon} />
                  )}
                </Flex>
                <Text color='#828282' fontSize='xs'>
                  Please attach your Photo, ID Proof
                </Text>
                {remarks?.PAN && (
                  <Button
                    fontSize={'10px'}
                    onClick={() => {
                      openRemarkModal('PAN')
                    }}
                    colorScheme='red'
                    variant='link'
                  >
                    View Remarks
                  </Button>
                )}
                <FileUpload
                  customStyleBoxWidth='200px'
                  id={2}
                  handleFileCancel={handleFileCancel}
                  subDescLink='Drag & drop here or Upload PAN'
                  getRootProps={PanFrontUpload.getRootProps}
                  getInputProps={PanFrontUpload.getInputProps}
                  preview={panFront}
                  previewUrl={panFrontPreview}
                  inputFieldImage={PospImages.AddressProofIcon}
                  excludeIds={reuploadValues}
                />
                <Text fontSize='10px' color='red'>
                  {apiErrors.pan_file}
                </Text>
              </Box>
            </Center>
          </Box>
          {isMobile && <Divider />}
          <Box px={6} borderRight={isMobile ? 'none' : '1px solid #D8D8D8'}>
            <Center flexDirection={'column'}>
              <Box>
                <Flex alignItems={'center'} justifyContent={'space-between'} pb={2}>
                  <Text color='#2C2C2C' fontSize='md'>
                    02. ADDRESS PROOF
                  </Text>
                  {checkVerificationStatus('AADHAR_FRONT') && (
                    <Image ml={1} height={'15px'} src={PospImages.CheckmarkDarkIcon} />
                  )}
                </Flex>
                <Text color='#828282' fontSize='xs' pb={2}>
                  Please attach your Aadhar Card
                </Text>
                {remarks?.AADHAR_FRONT && (
                  <Button
                    fontSize={'10px'}
                    onClick={() => {
                      openRemarkModal('AADHAR_FRONT')
                    }}
                    colorScheme='red'
                    variant='link'
                  >
                    View Remarks
                  </Button>
                )}
                <FileUpload
                  customStyleBoxWidth='200px'
                  id={4}
                  handleFileCancel={handleFileCancel}
                  subDescLink='Drag & drop here or Upload front side'
                  getRootProps={addressProofFrontUpload.getRootProps}
                  getInputProps={addressProofFrontUpload.getInputProps}
                  preview={addressProofFront}
                  previewUrl={addressProofFrontPreview}
                  inputFieldImage={PospImages.AddressProofIcon}
                  excludeIds={reuploadValues}
                />
                <Text fontSize='10px' color='red'>
                  {apiErrors.aadhar_front_file}
                </Text>
                {remarks?.AADHAR_BACK && (
                  <Button
                    fontSize={'10px'}
                    onClick={() => {
                      openRemarkModal('AADHAR_BACK')
                    }}
                    colorScheme='red'
                    variant='link'
                  >
                    View Remarks
                  </Button>
                )}
                <FileUpload
                  customStyleBoxWidth='200px'
                  id={5}
                  handleFileCancel={handleFileCancel}
                  subDescLink='Drag & drop here or Upload back side'
                  getRootProps={addressProofBackUpload.getRootProps}
                  getInputProps={addressProofBackUpload.getInputProps}
                  preview={addressProofBack}
                  previewUrl={addressProofBackPreview}
                  inputFieldImage={PospImages.AddressProofIcon}
                  excludeIds={reuploadValues}
                />
                <Text fontSize='10px' color='red'>
                  {apiErrors.aadhar_back_file}
                </Text>
              </Box>
            </Center>
          </Box>
          {isMobile && <Divider />}
          <Box px={6}>
            <Center flexDirection={'column'}>
              <Box>
                <Flex justifyContent='space-between' pb={2} alignItems={'center'}>
                  <Text color='#2C2C2C' fontSize='md'>
                    03. EDUCATION PROOF
                  </Text>
                  {checkVerificationStatus('DOCUMENTS') && (
                    <Image ml={1} height={'15px'} src={PospImages.CheckmarkDarkIcon} />
                  )}
                  {remarks?.DOCUMENTS && (
                    <Button
                      fontSize={'10px'}
                      onClick={() => {
                        openRemarkModal('DOCUMENTS')
                      }}
                      colorScheme='red'
                      variant='link'
                    >
                      View Remarks
                    </Button>
                  )}
                </Flex>

                <Select
                  placeholder='Select Proof'
                  size='sm'
                  color='GrayText'
                  width={200}
                  value={educationChoice}
                  isDisabled={checkVerificationStatus('DOCUMENTS')}
                  onChange={(e) => {
                    setEducationChoice(e.target.value)
                  }}
                >
                  {EducationOptions.map(({ value, label }, ind) => (
                    <option key={ind} value={value}>
                      {label}
                    </option>
                  ))}
                </Select>
                <FileUpload
                  customStyleBoxWidth='200px'
                  id={6}
                  handleFileCancel={handleFileCancel}
                  subDescLink='Drag & drop here or Upload document'
                  getRootProps={educationUpload.getRootProps}
                  getInputProps={educationUpload.getInputProps}
                  preview={education}
                  previewUrl={educationPreview}
                  inputFieldImage={PospImages.EducationIcon}
                  excludeIds={reuploadValues}
                />
                <Text fontSize='10px' color='red'>
                  {apiErrors.education_doc_file}
                </Text>
              </Box>
            </Center>
          </Box>

          {/* </Flex> */}
        </SimpleGrid>

        <Divider my={4} />

        <SimpleGrid columns={isMobile ? 1 : 3} spacing={8}>
          <Box borderRight={isMobile ? 'none' : '1px solid #D8D8D8'}>
            <Center flexDirection={'column'}>
              <Box>
                <Flex alignItems={'center'} justifyContent={'space-between'} pb={2}>
                  <Text color='#2C2C2C' fontSize='md'>
                    04. PHOTOGRAPH
                  </Text>
                  {checkVerificationStatus('PHOTOGRAPH') && (
                    <Image ml={1} height={'15px'} src={PospImages.CheckmarkDarkIcon} />
                  )}
                </Flex>
                {remarks?.PHOTOGRAPH && (
                  <Button
                    fontSize={'10px'}
                    onClick={() => {
                      openRemarkModal('PHOTOGRAPH')
                    }}
                    colorScheme='red'
                    variant='link'
                  >
                    View Remarks
                  </Button>
                )}
                <FileUpload
                  customStyleBoxWidth='200px'
                  id={7}
                  handleFileCancel={handleFileCancel}
                  subDescLink={
                    <>
                      <Text>Drag & drop here or Upload passport size photo</Text>
                      <Text fontSize='xx-small'>Acceptable Formats (JPG/JPEG/PNG)</Text>
                    </>
                  }
                  getRootProps={passportUpload.getRootProps}
                  getInputProps={passportUpload.getInputProps}
                  preview={passport}
                  previewUrl={passportPreview}
                  inputFieldImage={PospImages.PassportIcon}
                  excludeIds={reuploadValues}
                />
                <Text fontSize='10px' color='red'>
                  {apiErrors.photo_file}
                </Text>
              </Box>
            </Center>
          </Box>
          {isMobile && <Divider />}
          <Box borderRight={isMobile ? 'none' : '1px solid #D8D8D8'}>
            <Center flexDirection={'column'}>
              <Box>
                <Flex alignItems={'center'} justifyContent={'space-between'} pb={2}>
                  <Text color='#2C2C2C' fontSize='md'>
                    05. BANK DETAILS
                  </Text>
                  {checkVerificationStatus('BANK_DETAILS') && (
                    <Image ml={1} height={'15px'} src={PospImages.CheckmarkDarkIcon} />
                  )}
                </Flex>
                {remarks?.BANK_DETAILS && (
                  <Button
                    fontSize={'10px'}
                    onClick={() => {
                      openRemarkModal('BANK_DETAILS')
                    }}
                    colorScheme='red'
                    variant='link'
                  >
                    View Remarks
                  </Button>
                )}
                <Select
                  mt={2}
                  placeholder='Select Proof'
                  size='sm'
                  color='GrayText'
                  width={200}
                  value={bankChoice}
                  isDisabled={checkVerificationStatus('BANK_DETAILS')}
                  onChange={(e) => {
                    setBankChoice(e.target.value)
                  }}
                >
                  {BankOptions.map(({ value, label }, ind) => (
                    <option key={ind} value={value}>
                      {label}
                    </option>
                  ))}
                </Select>
                <FileUpload
                  //   customStyleBoxWidth="227px"
                  customStyleBoxWidth='200px'
                  id={8}
                  handleFileCancel={handleFileCancel}
                  subDescLink='Drag & drop here or Upload document'
                  //   iconWidth="60px"
                  //   iconHeight="60px"
                  getRootProps={checkUpload.getRootProps}
                  getInputProps={checkUpload.getInputProps}
                  preview={cheque}
                  previewUrl={chequePreview}
                  inputFieldImage={PospImages.ChequeIcon}
                  excludeIds={reuploadValues}
                />
                <Text fontSize='10px' color='red'>
                  {apiErrors.bank_details_doc_file}
                </Text>
              </Box>
            </Center>
          </Box>
          {isMobile && noc && <Divider />}
          {noc && (
            <Box px={6} borderRight={isMobile ? 'none' : '1px solid #D8D8D8'}>
              <Center flexDirection={'column'}>
                <Box>
                  <Flex alignItems={'center'} justifyContent={'space-between'} pb={2}>
                    <Text color='#2C2C2C' fontSize='md'>
                      06. NOC
                    </Text>
                    {checkVerificationStatus('NOC') && (
                      <Image ml={1} height={'15px'} src={PospImages.CheckmarkDarkIcon} />
                    )}
                  </Flex>
                  {remarks?.NOC && (
                    <Button
                      fontSize={'10px'}
                      onClick={() => {
                        openRemarkModal('NOC')
                      }}
                      colorScheme='red'
                      variant='link'
                    >
                      View Remarks
                    </Button>
                  )}
                  <FileUpload
                    customStyleBoxWidth='200px'
                    id={1}
                    handleFileCancel={handleFileCancel}
                    subDescLink='Drag & drop here or Upload Noc'
                    getRootProps={nocUpload.getRootProps}
                    getInputProps={nocUpload.getInputProps}
                    preview={noc}
                    previewUrl={nocPreview}
                    inputFieldImage={PospImages.PassportIcon}
                    excludeIds={reuploadValues}
                  />
                  <Text fontSize='10px' color='red'>
                    {apiErrors.photo_file}
                  </Text>
                </Box>
              </Center>
            </Box>
          )}

          {isMobile && <Divider />}
          <Box px={noc ? 0 : 6}>
            <Center flexDirection={'column'}>
              <Box>
                <Flex alignItems={'center'} justifyContent={'space-between'} pb={2}>
                  <Text color='#2C2C2C' fontSize='md'>
                    {noc ? '07. GST DETAILS' : '06. GST DETAILS'}
                  </Text>
                  {checkVerificationStatus('GST') && (
                    <Image ml={1} height={'15px'} src={PospImages.CheckmarkDarkIcon} />
                  )}
                </Flex>

                {remarks?.GST && (
                  <Button
                    fontSize={'10px'}
                    onClick={() => {
                      openRemarkModal('GST')
                    }}
                    colorScheme='red'
                    variant='link'
                  >
                    View Remarks
                  </Button>
                )}

                <Box mt={3} mb={3}>
                  <Text fontSize='xs' color='gray.500' mb={2} fontWeight='medium'>
                    Do you have GST certificate?
                  </Text>
                  <Flex
                    bg='gray.100'
                    p={1}
                    borderRadius='xl'
                    width={200}
                    position='relative'
                    cursor='pointer'
                    userSelect='none'
                    border='1px solid'
                    borderColor='gray.200'
                  >
                    {/* "Yes" option */}
                    <Box
                      flex={1}
                      py={1.5}
                      borderRadius='lg'
                      bg={hasGst ? 'white' : 'transparent'}
                      boxShadow={hasGst ? 'sm' : 'none'}
                      transition='all 0.2s ease-in-out'
                      onClick={() => !checkVerificationStatus('GST') && setHasGst(true)}
                    >
                      <Center>
                        <Text
                          fontSize='xs'
                          fontWeight={hasGst ? 'semibold' : 'medium'}
                          color={hasGst ? 'blue.600' : 'gray.600'}
                        >
                          Yes
                        </Text>
                      </Center>
                    </Box>

                    {/* "No" option */}
                    <Box
                      flex={1}
                      py={1.5}
                      borderRadius='lg'
                      bg={!hasGst ? 'white' : 'transparent'}
                      boxShadow={!hasGst ? 'sm' : 'none'}
                      transition='all 0.2s ease-in-out'
                      onClick={() => {
                        if (!checkVerificationStatus('GST')) {
                          setHasGst(false)
                          setGstNumber('')
                        }
                      }}
                    >
                      <Center>
                        <Text
                          fontSize='xs'
                          fontWeight={!hasGst ? 'semibold' : 'medium'}
                          color={!hasGst ? 'blue.600' : 'gray.600'}
                        >
                          No
                        </Text>
                      </Center>
                    </Box>
                  </Flex>
                </Box>

                {hasGst === true && (
                  <>
                    <Input
                      mt={3}
                      size='sm'
                      width={200}
                      placeholder='Enter 15-digit GST Number'
                      value={gstNumber}
                      maxLength={15}
                      isInvalid={gstNumber.length > 0 && !strictGstRegex.test(gstNumber)}
                      isDisabled={checkVerificationStatus('GST')}
                      onChange={(e) => {
                        const val = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 15)
                        setGstNumber(val)
                      }}
                    />
                    <Text mt={1.5} fontSize='10px' color='red'>
                      {apiErrors.gst_number}
                    </Text>
                    {gstNumber.length > 0 && gstNumber.length < 15 && (
                      <Text mt={1.5} fontSize='10px' color='red' width={200}>
                        GST number must be 15 characters long.
                      </Text>
                    )}
                    {gstNumber.length === 15 && !strictGstRegex.test(gstNumber) && (
                      <Text mt={1.5} fontSize='10px' color='red' width={200}>
                        Invalid GST format (e.g., 07AAAAA1111A1Z1).
                      </Text>
                    )}
                  </>
                )}

                <FileUpload
                  customStyleBoxWidth='200px'
                  id={9}
                  handleFileCancel={handleFileCancel}
                  subDescLink={
                    hasGst
                      ? 'Drag & drop here or Upload GST Certificate'
                      : 'Drag & drop here or Upload GST Declaration'
                  }
                  getRootProps={gstDocUpload.getRootProps}
                  getInputProps={gstDocUpload.getInputProps}
                  preview={gstDoc}
                  previewUrl={gstDocPreview}
                  inputFieldImage={PospImages.EducationIcon}
                  excludeIds={reuploadValues}
                />

                <Text fontSize='10px' color='red'>
                  {apiErrors.gst_doc_file}
                </Text>
              </Box>
            </Center>
          </Box>
        </SimpleGrid>

        <Center mt={8}>
          <Button
            color='#1C6DA2'
            border='1px solid #1C6DA2'
            variant='outline'
            fontWeight='normal'
            fontSize={'sm'}
            px={8}
            onClick={() => navigate('/registration-status')}
            mr={10}
          >
            Back
          </Button>
          <Button
            fontWeight='normal'
            fontSize={'sm'}
            onClick={handleFileUpload}
            px={8}
            isDisabled={
              !(
                panFront &&
                educationChoice &&
                bankChoice &&
                addressProofBack &&
                addressProofFront &&
                education &&
                passport &&
                cheque &&
                (isRegistered === USER_REGISTRATION_TYPE.registered ? !!noc : true) &&
                checkRemarkResolved() &&
                (hasGst ? !!gstDoc && strictGstRegex.test(gstNumber) : !!gstDoc)
              )
            }
          >
            Verify
          </Button>
        </Center>
      </Container>
    </Layout>
  )
}

export default DocumentUpload
